import React, {
  useEffect,
  useRef,
  useState
} from "react";

const MAX_WAIT_ATTEMPTS = 40;
const WAIT_INTERVAL_MS = 150;

const waitForTurnstile = () =>
  new Promise((resolve, reject) => {
    let attempts = 0;

    const timer = window.setInterval(() => {
      attempts += 1;

      if (window.turnstile) {
        window.clearInterval(timer);
        resolve(window.turnstile);
        return;
      }

      if (attempts >= MAX_WAIT_ATTEMPTS) {
        window.clearInterval(timer);

        reject(
          new Error(
            "A API do Cloudflare não ficou disponível."
          )
        );
      }
    }, WAIT_INTERVAL_MS);
  });

const Turnstile = ({
  action,
  onToken,
  resetKey = 0,
  theme = "auto"
}) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const mountedRef = useRef(false);
  const onTokenRef = useRef(onToken);

  const [status, setStatus] =
    useState("loading");

  const [errorCode, setErrorCode] =
    useState("");

  const siteKey =
    process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect(() => {
    onTokenRef.current = onToken;
  }, [onToken]);

  useEffect(() => {
    mountedRef.current = true;

    const renderWidget = async () => {
      setStatus("loading");
      setErrorCode("");
      onTokenRef.current("");

      if (!siteKey) {
        setStatus("error");
        setErrorCode("SITE_KEY_AUSENTE");
        return;
      }

      try {
        const turnstile =
          await waitForTurnstile();

        if (
          !mountedRef.current ||
          !containerRef.current
        ) {
          return;
        }

        containerRef.current.innerHTML = "";

        widgetIdRef.current =
          turnstile.render(
            containerRef.current,
            {
              sitekey: siteKey,
              action,
              theme,
              appearance: "always",
              execution: "render",
              retry: "auto",
              "retry-interval": 1500,
              "refresh-expired": "auto",
              "refresh-timeout": "auto",

              callback: token => {
                if (
                  !mountedRef.current ||
                  !token
                ) {
                  return;
                }

                setStatus("solved");
                setErrorCode("");
                onTokenRef.current(token);
              },

              "expired-callback": () => {
                if (!mountedRef.current) {
                  return;
                }

                setStatus("loading");
                onTokenRef.current("");
              },

              "timeout-callback": () => {
                if (!mountedRef.current) {
                  return;
                }

                setStatus("loading");
                onTokenRef.current("");
              },

              "error-callback": code => {
                if (!mountedRef.current) {
                  return true;
                }

                console.warn(
                  "[Korax Turnstile] Erro:",
                  code
                );

                setErrorCode(
                  String(code || "DESCONHECIDO")
                );

                setStatus("error");
                onTokenRef.current("");

                return false;
              }
            }
          );
      } catch (error) {
        if (!mountedRef.current) {
          return;
        }

        console.warn(
          "[Korax Turnstile] Falha ao iniciar:",
          error
        );

        setStatus("error");
        setErrorCode("SCRIPT_INDISPONIVEL");
        onTokenRef.current("");
      }
    };

    renderWidget();

    return () => {
      mountedRef.current = false;

      if (
        window.turnstile &&
        widgetIdRef.current !== null
      ) {
        try {
          window.turnstile.remove(
            widgetIdRef.current
          );
        } catch (_) {}
      }

      widgetIdRef.current = null;
    };
  }, [
    action,
    resetKey,
    siteKey,
    theme
  ]);

  const handleRetry = () => {
    if (
      !window.turnstile ||
      widgetIdRef.current === null
    ) {
      window.location.replace(
        "/login?retry=" + Date.now()
      );

      return;
    }

    try {
      setStatus("loading");
      setErrorCode("");
      onTokenRef.current("");

      window.turnstile.reset(
        widgetIdRef.current
      );
    } catch (_) {
      window.location.replace(
        "/login?retry=" + Date.now()
      );
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: 82,
        margin: "12px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div
        ref={containerRef}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center"
        }}
      />

      {status === "loading" && (
        <div
          style={{
            marginTop: 7,
            color:
              "rgba(255,255,255,.62)",
            fontSize: 11,
            textAlign: "center"
          }}
        >
          Preparando verificação segura...
        </div>
      )}

      {status === "solved" && (
        <div
          style={{
            marginTop: 7,
            color: "#86EFAC",
            fontSize: 11,
            fontWeight: 700,
            textAlign: "center"
          }}
        >
          ✓ Verificação concluída
        </div>
      )}

      {status === "error" && (
        <div
          style={{
            marginTop: 8,
            color: "#FCA5A5",
            fontSize: 12,
            lineHeight: 1.45,
            textAlign: "center"
          }}
        >
          Não foi possível concluir a verificação.

          <div
            style={{
              marginTop: 3,
              color:
                "rgba(255,255,255,.45)",
              fontSize: 10
            }}
          >
            Código: {errorCode}
          </div>

          <button
            type="button"
            onClick={handleRetry}
            style={{
              display: "block",
              margin: "9px auto 0",
              padding: "7px 12px",
              borderRadius: 9,
              border:
                "1px solid rgba(255,255,255,.18)",
              background:
                "rgba(255,255,255,.08)",
              color: "#FFFFFF",
              fontFamily: "inherit",
              fontSize: 11,
              fontWeight: 800,
              cursor: "pointer"
            }}
          >
            Tentar novamente
          </button>
        </div>
      )}
    </div>
  );
};

export default Turnstile;
